import { Icon, Tooltip } from "@monta/design-system";
import styles from "./notificationsIcon.module.scss";
import { fixString } from "@monta/router-js";
const NotificationsIcon = () => {
  return (
    <Tooltip text={"رخداد ها"}>
      <a
        className={styles["event"]}
        href={fixString("/#!oldPopup;a144=notification", "GWT_URL")}
      >
        <Icon icon={"mi-bell"} size={1.5} className={styles["event__icon"]} />
      </a>
    </Tooltip>
  );
};

export default NotificationsIcon;
